export default __webpack_public_path__ + "static/media/topcharacter2.588debdd.jpeg";